/* LADDOM announcement bar — Module 06.
   Cross-fade + 8px vertical drift. Never a horizontal slide, never a marquee.
   Pauses on hover, on focus-within, and when the tab is hidden. */
(function () {
  'use strict';

  class LdAnnounce extends HTMLElement {
    connectedCallback() {
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-announce-item]'));
      this.index = 0;
      this.timer = null;
      this.paused = false;
      this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.key = this.dataset.key;

      var close = this.querySelector('[data-announce-close]');
      if (close) {
        // sessionStorage, not localStorage: the merchant changes the message
        // and a dismissed visitor should see the new one next session.
        if (window.sessionStorage.getItem(this.key) === 'dismissed') {
          this.hidden = true;
          return;
        }
        close.addEventListener('click', () => {
          window.sessionStorage.setItem(this.key, 'dismissed');
          this.hidden = true;
        });
      }

      // A single message runs no timer at all.
      if (this.items.length < 2) return;

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.resume());

      this._vis = () => (document.hidden ? this.pause() : this.resume());
      document.addEventListener('visibilitychange', this._vis);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this._vis);
    }

    start() {
      this.stop();
      if (this.paused || this.items.length < 2) return;
      this.timer = window.setInterval(() => this.next(), this.speed);
    }
    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }
    pause() {
      this.paused = true;
      this.stop();
    }
    resume() {
      if (document.hidden) return;
      this.paused = false;
      this.start();
    }

    next() {
      var prev = this.items[this.index];
      this.index = (this.index + 1) % this.items.length;
      var cur = this.items[this.index];

      prev.classList.remove('is-active');
      prev.setAttribute('aria-hidden', 'true');
      cur.classList.add('is-active');
      cur.removeAttribute('aria-hidden');
    }
  }

  if (!customElements.get('ld-announce')) customElements.define('ld-announce', LdAnnounce);
})();
